import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";


const EmployeeGoalSummary = () => {
  const {id} = useParams()
  const formatFinancialYear = (year: number) => {
    const nextYearShort = (year + 1).toString().slice(-2);
    return `${year}-${nextYearShort}`;
  };
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    const fyStart = month >= 3 ? year : year - 1;
    return formatFinancialYear(fyStart);
  };
  const [finance_year, setFinance_year] = useState(getCurrentFinancialYear());
  const [allItemList, setAllItemList] = useState<any[]>([]);
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const {
    data: getcategoryResponse,
    loading: getCategoryLoading,
    error: getCategoryError,
  } = useApi("/api/manager/view-employee-category", {
    method: "POST",
    payload: {
      category_id: id,
    },
    autoCall: true,
    dependencies: [count],
  });

  useEffect(() => {
    setAllItemList(getcategoryResponse?.data);
  }, [getcategoryResponse]);

  const handleBack = () => {
    localStorage.removeItem("GoalsProfileEmployeeID");
    navigate("/pms-employee-goals");
  };

  const handleNavigation = (id:any) => {
    navigate(`/pms-employee-performance-review/${id}`);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Goals Summary</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Dashboard</li>
                <li className="breadcrumb-item active" aria-current="page">
                  Goals Summary
                </li>
              </ol>
            </nav>
          </div>
          <div className="head-icons ms-2 d-flex gap-2">
            <button className="btn btn-outline-secondary" onClick={handleBack}>
              ← Back
            </button>
            <CollapseHeader />
          </div>
        </div>
        <div className="card">
          <div className="card-header">
            <h5>Goals Summary</h5>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered table-hover">
                <thead className="table-light">
                  <tr>
                    <th>S No</th>
                    <th>Goal Profile</th>
                    <th>Goal Profile Description</th>
                    {/* <th>KRA</th> */}
                    <th>KRA/Behavioural Competency</th>
                    {/* <th>Profile Edit</th>
                    <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {allItemList && allItemList.length > 0 ? (
                    allItemList.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.category_name}</td>
                        <td>{item.category_description}</td>
                        <td>
                          <button
                            className="btn btn-sm btn-secondary"
                            onClick={()=>handleNavigation(item.category_id)}
                          >
                            <i className="ti-eye" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={5} className="text-center text-muted p-5">
                        No goal profile found for this employee.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
        {/* Footer */}
      </div>
      <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3 mt-4">
        <p className="mb-0">
          © {new Date().getFullYear()} WeConnect. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default EmployeeGoalSummary;
